import { render, staticRenderFns } from "./Sponsor.vue?vue&type=template&id=5c5c8965&scoped=true"
import script from "./Sponsor.vue?vue&type=script&lang=js"
export * from "./Sponsor.vue?vue&type=script&lang=js"
import style0 from "./Sponsor.vue?vue&type=style&index=0&id=5c5c8965&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5c8965",
  null
  
)

export default component.exports